import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  Box,
  SimpleGrid,
  Button,
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  PinInput,
  PinInputField,
  Spinner,
  Text,
  Heading,
  VStack,
  Flex,
  Input,
  NumberInput,
  NumberInputField,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  Center,
  Icon,
  Skeleton,
  SkeletonText,
  useToast,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { FiChevronLeft, FiPlus, FiArrowLeft } from "react-icons/fi";

import Card from "components/card/Card.js";
import Bank from "./components/Bank.js";
import Paginate from "components/navigation/Paginate.js";

export default function Transfer() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [loading, setLoading] = useState(false);
  const [account, setAccount] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [walletLoading, setWalletLoading] = useState(true);
  const [accountsIsLoading, setAccountsIsLoading] = useState(true);
  const [wallet, setWallet] = useState(null);
  const [transfer, setTransfer] = useState(false);
  const [amount, setAmount] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pageCount, setPageCount] = useState(0);
  const [from, setFrom] = useState(0);
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [pin1, setPin1] = useState("");
  const [pin2, setPin2] = useState("");
  const [pin3, setPin3] = useState("");
  const [pin4, setPin4] = useState("");
  const [pin5, setPin5] = useState("");
  const [pin6, setPin6] = useState("");
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(false);

  const {
    isOpen: isTransferOpen,
    onOpen: onTransferOpen,
    onClose: onTransferClose,
  } = useDisclosure();

  const userState = useSelector((state) => state?.user?.value);
  const token = userState.hasOwnProperty("token") ? userState.token : null;
  const toast = useToast();

  const findBeneficiary = async () => {
    try {
      const { data: response } = await axios.post(
        SERVER_URL + "/transfer/findBeneficiary",
        { beneficiaryName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        setAccounts(response.data);
      }
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const getAccounts = async (from) => {
    try {
      const { data: response } = await axios.post(
        SERVER_URL + "/user/accounts",
        { from, limit },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setAccountsIsLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setAccountsIsLoading(false);
        return;
      }
      if (response.success) {
        setPageCount(response.data.count / limit);
        setAccounts(response.data.accounts);
        setAccountsIsLoading(false);
      }
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setAccountsIsLoading(false);
    }
  };

  const getWallet = async (from) => {
    try {
      const { data: response } = await axios.get(SERVER_URL + "/wallet/me", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setWalletLoading(false);
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        setWalletLoading(false);
        return;
      }
      if (response.success) {
        setWallet(response.data);
        setWalletLoading(false);
      }
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
  };

  const transerFund = async () => {
    try {
      if ((parseFloat(amount)+50) > wallet.balance) {
        toast({
          title: "You have insufficient balance to make this transfer",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (otp === "") {
        toast({
          title:
            "Please enter your 6 Digit Pin or go to settings to create one",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      setLoading(true);
      const { data: response } = await axios.post(
        SERVER_URL + "/transfer",
        { amount, accountId: account._id, otp },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      if (response.error) {
        toast({
          title: response.error || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (!response.success) {
        toast({
          title: response.message || "An error occured",
          status: "error",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
        return;
      }
      if (response.success) {
        toast({
          title: response.message,
          status: "success",
          duration: 9000,
          position: "top-right",
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: error.message || "An error occured",
        status: "error",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getAccounts();
    getWallet();
  }, []);

  useEffect(() => {
    setOtp(pin1 + "" + pin2 + "" + pin3 + "" + pin4 + "" + pin5 + "" + pin6);
  }, [pin1, pin2, pin3, pin4, pin5, pin6, otp]);

  const textColorPrimary = useColorModeValue("secondaryGray.500", "white");
  const textColorSecondary = useColorModeValue("gray.700", "gray.100");
  const backgroundColor = useColorModeValue("white", "brand.700");
  const bg = useColorModeValue("brand.500", "gray.100");
  const color = useColorModeValue("white", "brand.500");

  return (
    <>
      {account !== null && (
        <Modal isOpen={isTransferOpen} onClose={onTransferClose} size={"md"}>
          <ModalOverlay />
          <ModalContent color={textColorSecondary} background={backgroundColor}>
            <ModalHeader color={textColorSecondary}>
              <Icon
                as={FiArrowLeft}
                onClick={onTransferClose}
                width="20px"
                height="20px"
                color={textColorPrimary}
              />
            </ModalHeader>
            <ModalCloseButton color={textColorSecondary} />
            <ModalBody>
              <SimpleGrid>
                <Box>
                  <Heading
                    as="h5"
                    color={textColorPrimary}
                    size={{ base: "sm", lg: "md" }}
                  >
                    Confirm Transfer
                  </Heading>
                </Box>

                <Box>
                  <VStack spacing={4} align="stretch">
                    <Box w="100%" mt="4">
                      <Center width="100%">Transferring</Center>
                    </Box>
                    <Box w="100%">
                      <Center width="100%">
                        <Text fontWeight="bold" fontSize="19">
                          {" "}
                          N {amount}{" "}
                        </Text>
                      </Center>
                    </Box>

                    <Box w="100%">
                      <Center width="100%">
                        <Text
                          fontWeight="bold"
                          textAlign="center"
                          fontSize="16"
                        >
                          {" "}
                          {account.accountNumber} <br />({account.accountName}){" "}
                          {account.bankName}{" "}
                        </Text>
                      </Center>
                    </Box>

                    <Box pt="3" pb="5">
                      <Box width="100%">
                        <Text
                          textAlign="center"
                          fontWeight="bold"
                          color={textColorSecondary}
                        >
                          Enter 6 Digit Pin
                        </Text>
                      </Box>
                      <Center width="100%">
                        <PinInput otp>
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin1(e.target.value);
                            }}
                          />
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin2(e.target.value);
                            }}
                          />
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin3(e.target.value);
                            }}
                          />
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin4(e.target.value);
                            }}
                          />
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin5(e.target.value);
                            }}
                          />
                          <PinInputField
                            w="55px"
                            h="55px"
                            onChange={(e) => {
                              setPin6(e.target.value);
                            }}
                          />
                        </PinInput>
                        {loading && <Spinner ml="1" />}
                      </Center>
                    </Box>

                    <Box w="100%" minH="40px" mt="4" p="4">
                      <Button
                        fontSize="sm"
                        variant="brand"
                        bg={bg}
                        color={color}
                        fontWeight="500"
                        w="100%"
                        h="50"
                        _hover={{
                          bg: "blue.500",
                          color: "white",
                        }}
                        isLoading={loading}
                        loadingText="Please Wait.."
                        mb="24px"
                        onClick={(e) => {
                          e.preventDefault();
                          transerFund();
                        }}
                      >
                        Transfer
                      </Button>
                    </Box>
                  </VStack>
                </Box>
              </SimpleGrid>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {transfer === false ? (
        <Accounts
          accounts={accounts}
          setAccount={setAccount}
          setTransfer={setTransfer}
          setFrom={setFrom}
          pageCount={pageCount}
          getAccounts={getAccounts}
          accountsIsLoading={accountsIsLoading}
          setBeneficiaryName={setBeneficiaryName}
          findBeneficiary={findBeneficiary}
        />
      ) : (
        <Tranfer
          wallet={wallet}
          account={account}
          transerFund={transerFund}
          setTransfer={setTransfer}
          setAmount={setAmount}
          loading={loading}
          onTransferOpen={onTransferOpen}
          amount={amount}
          error={error}
          setError={setError}
        />
      )}
    </>
  );
}

const AccountsLoading = () => {
  return (
    <>
      <Card align="center" p="20px" mt="10px">
        <Stack>
          <Skeleton height="30px" />
          <SkeletonText mt="5" noOfLines={5} spacing="4" />
          <Skeleton height="30px" />
        </Stack>
      </Card>
      <Card align="center" p="20px" mt="10px">
        <Stack>
          <Skeleton height="30px" />
          <SkeletonText mt="5" noOfLines={5} spacing="4" />
          <Skeleton height="30px" />
        </Stack>
      </Card>
    </>
  );
};

const Tranfer = (props) => {
  const {
    account,
    setTransfer,
    setAmount,
    wallet,
    onTransferOpen,
    setError,
    error,
    loading,
  } = props;
  const textColorSecondary = useColorModeValue("gray.700", "gray.100");
  const inputColor = useColorModeValue("brand.500", "gray.100");
  return (
    <>
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <SimpleGrid
          columns={{ base: 1, sm: 1, md: 2, lg: 2 }}
          spacing="2"
          mb="3"
        >
          <Box textAlign="start">
            <Flex
              onClick={(e) => {
                setTransfer(false);
              }}
            >
              <Icon as={FiChevronLeft} w={10} h={10} /> <Text mt="2">Back</Text>
            </Flex>
          </Box>
          <Box textAlign="right"></Box>
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 2 }}>
          <Card align="center" p="20px">
            <Stack spacing={4} w={"full"} maxW={"md"} p={6} my={5}>
              <FormControl>
                <FormLabel color={textColorSecondary} fontWeight="bold">
                  Bank Name
                </FormLabel>
                <Input
                  type="text"
                  color={inputColor}
                  value={account.bankName}
                  borderRadius="20"
                  readOnly
                />
              </FormControl>

              <FormControl>
                <FormLabel color={textColorSecondary} fontWeight="bold">
                  Beneficiary
                </FormLabel>
                <Input
                  type="text"
                  color={inputColor}
                  value={
                    account.accountNumber + "(" + account.accountName + ")"
                  }
                  borderRadius="20"
                  readOnly
                />
              </FormControl>

              <FormControl isInvalid={error}>
                <FormLabel color={textColorSecondary} fontWeight="bold">
                  Amount
                </FormLabel>
                <NumberInput precision={2}>
                  <NumberInputField
                    color={inputColor}
                    borderRadius="20"
                    onChange={(e) => {
                      setAmount(e.target.value);
                      const nairaAmount = parseFloat(e.target.value) + 50;
                      if (nairaAmount > wallet.balance) {
                        setError(true);
                      }else{
                        setError(false);
                      }
                    }}
                  />
                </NumberInput>
                <FormHelperText>
                  <b>Transfer Fee:</b> NGN 50
                </FormHelperText>
                {error && (
                  <Center>
                    <FormErrorMessage textAlign="center">
                      Insufficient wallet balance
                    </FormErrorMessage>
                  </Center>
                )}
              </FormControl>

              <Button
                isLoading={loading}
                bg={useColorModeValue("brand.500", "gray.100")}
                color={useColorModeValue("white", "brand.500")}
                w="full"
                mt="2"
                disabled={error}
                borderRadius="20"
                _hover={{
                  bg: "blue.500",
                  color: "white",
                }}
                loadingText="Wait.."
                onClick={(e) => {
                  onTransferOpen();
                }}
              >
                Proceed
              </Button>
            </Stack>
          </Card>
        </SimpleGrid>
      </Box>
    </>
  );
};

const Accounts = (props) => {
  const {
    accounts,
    setAccount,
    getAccounts,
    pageCount,
    setTransfer,
    setFrom,
    setBeneficiaryName,
    findBeneficiary,
    accountsIsLoading,
  } = props;
  const inputColor = useColorModeValue("brand.500", "gray.100");
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 2 }} spacing="2">
        <Box textAlign="right">
          <FormControl>
            <Input
              type="text"
              color={inputColor}
              onChange={(e) => {
                setBeneficiaryName(e.target.value);
              }}
              placeHolder="Search for beneficiary"
              onKeyUp={findBeneficiary}
              borderRadius="20"
              maxLength="100"
            />
          </FormControl>
        </Box>
        <Box textAlign="right">
          <Link to="/user/addaccount">
            <Button
              fontSize={{ base: "xs", sm: "xs", md: "sm", lg: "sm" }}
              rightIcon={
                <Icon as={FiPlus} width="15px" height="15px" color="white" />
              }
              variant="primary"
              background="brand.500"
            >
              Create Beneficiary
            </Button>
          </Link>
        </Box>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, sm: 1, md: 3, lg: 3 }} spacing="2">
        {!accountsIsLoading ? (
          accounts.map((bankaccount) => (
            <Bank
              key={bankaccount.accountNumber}
              account={bankaccount}
              setTransfer={setTransfer}
              setAccount={setAccount}
            />
          ))
        ) : (
          <AccountsLoading />
        )}
      </SimpleGrid>
      {accounts.length > 0 && (
        <Box width="100%" mt="10" textAlign="center">
          <Center width="100%">
            <Paginate
              pageCount={pageCount}
              setFrom={setFrom}
              getRecords={getAccounts}
            />
          </Center>
        </Box>
      )}
      {accounts.length === 0 && (
        <Box width="100%" mt="10" textAlign="center">
          <Center width="100%">
            <Text>No accounts added yet</Text>
          </Center>
        </Box>
      )}
    </Box>
  );
};
